import { render, staticRenderFns } from "./EditImg.vue?vue&type=template&id=b735dba6&scoped=true&"
import script from "./EditImg.vue?vue&type=script&lang=js&"
export * from "./EditImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b735dba6",
  null
  
)

export default component.exports